<template>
  <div>

    <div class="bar">
      <div class="toolbar van-hairline--bottom">
        <div class="tool-item" @click="orderStatus.show = true">状态：{{ orderStatusList }}<span
            class="caret"></span></div>
      </div>
      <!--      <div class="toolbar van-hairline&#45;&#45;bottom">-->
      <!--        <div class="tool-item " @click="orderType.show = true">类型：{{ orderTypeList }}<span-->
      <!--            class="caret"></span></div>-->
      <!--      </div>-->
    </div>

    <van-search v-model.trim="keyword" class="search-bar" shape="round" show-action placeholder="搜索店员名称/订单号"
                @search="onSearch">
      <div slot="action" @click="onSearch">
        搜索
      </div>
    </van-search>

    <van-list
        class="orderlist"
        v-model="loading"
        :finished="listFinished"
        @load="loadData"
        finished-text="没有更多了">
      <div class="list-item" v-for="(item, index) in list" :key="index">
        <div class="dataBox">
          <div class="wechat">申请店员： {{ item.clerkName }}</div>
        </div>
        <div>订单号：{{ item.orderNo }}</div>
        <div>订单类型：{{ $store.state.OrderTypeEnum.getLabel(item.type) }}</div>
        <div>订单金额：{{ formatPrice(item.amount) }}</div>
        <div>申请时间： {{ formatDate(item.createTime, 'MM-DD HH:mm') }}</div>
        <div v-if="item.message" class="tags">
          <div>备注：{{ item.message }}</div>
        </div>
        <div v-if="item.photoUrls != null && item.photoUrls.length > 0">申请截图：</div>
        <div class="img-box">
          <div class="img-style" v-for="(img,imgIndex) of item.photoUrls" :key="imgIndex + 'a'">
            <img :src="img" @click.stop="HandleclickImg(item.photoUrls,imgIndex)">
          </div>
          <div v-for="index in 3" :key="index + 'b'" class="img-no"></div>
        </div>
        <div v-if="item.objectRole">审批人： {{item.objectRole}}-{{item.objectName}}</div>
        <div v-if="item.status == 2">未通过原因：{{item.reason?item.reason:''}}</div>
        <div class="status">
          <van-tag v-if="item.status == 0" plain type="primary">未审核</van-tag>
          <van-tag v-if="item.status == 1" plain type="success">已通过</van-tag>
          <van-tag v-if="item.status == 2" plain type="danger">未通过</van-tag>
        </div>

        <div v-if="item.status == 0 && $KfPermission.continuedOrderCheck">
          <div class="statusBtn" @click.stop="statusBtn(item.id)" >通过</div>
          <div class="noBtn" @click.stop="reason.show=true,reason.id=item.id">不通过</div>
        </div>
      </div>
    </van-list>

    <van-action-sheet
        v-model="orderStatus.show"
        :actions="orderStatus.actions"
        cancel-text="取消"
        @select="onClerkStatus"/>

    <!--上拉选择申请类型-->
    <van-action-sheet
        v-model="orderType.show"
        :actions="orderType.actions"
        cancel-text="取消"
        @select="onCherkType"/>
    <van-dialog v-model="reason.show" title="不通过原因" show-cancel-button :before-close="noPass">
      <div class="padding-sm">
        <van-field
            v-model="reason.noPassReason"
            :autosize="100"
            maxlength="100"
            type="textarea"
            placeholder="请输入不通过原因"
            show-word-limit
            style="border: 1px solid #efefef"
        />
      </div>
    </van-dialog>
  </div>
</template>

<script>
import Vue from 'vue';
import {ActionSheet, Dialog, List, CellGroup, Cell, Tag, Toast, Search, ImagePreview} from 'vant';
import {continuedApplyList, verifyOrderContinuedApply} from '@/api/kf/order';
import moment from "moment";
import Decimal from "decimal.js";

Vue.use(ActionSheet)
    .use(Dialog)
    .use(List)
    .use(CellGroup)
    .use(Cell)
    .use(Tag)
    .use(Toast)
    .use(Search)


export default {
  name: "continued-apply",

  data() {
    return {
      list: null,
      type: null,
      status: null,
      pageNo: 1,
      pageSize: 10,
      keyword: null,
      loading: false,
      listFinished: false,


      orderStatus: {
        show: false,
        actions: [
          {name: '全部', value: null},
          {name: '待审核', value: 0},
          {name: '已通过', value: 1},
          {name: '未通过', value: 2},
        ]
      },

      orderType: {
        show: false,
        actions: [
          {name: '全部', value: null},
          {name: '指定单', value: 'assigned'},
          {name: '随机单', value: 'random'},
          {name: '打赏单', value: 'reward'},
        ]
      },
      reason: {
        show: false,
        id: null,
        noPassReason: null
      },
    }
  },

  computed: {
    orderStatusList() {
      if (this.status == 0) {
        return '待审核'
      }
      if (this.status == 1) {
        return '已通过'
      }
      if (this.status == 2) {
        return '未通过'
      }
      return '全部'
    },

    orderTypeList() {
      if (this.type == 'assigned') {
        return '指定单'
      }
      if (this.type == 'random') {
        return '随机单'
      }
      if (this.type == 'reward') {
        return '打赏单'
      }
      return '全部'
    }
  },

  methods: {
    formatPrice(price) {
      if (price != null) {
        return Decimal.div(price, 100).toString()
      }
      return ''
    },
    onSearch() {
      this.loadData(true)
    },
    noPass(action, done) {
      if (action == 'confirm') {
        Toast.loading({
          mask: true,
          message: '请稍候'
        })
        verifyOrderContinuedApply(this.reason.id, 2, this.reason.noPassReason).then((res) => {
          Toast.clear()
          const data = res.data
          if (data.code == 0) {
            this.loadData(true)
            done()
            return Toast.success('审核成功')
          } else {
            done(false)
            Toast.fail(data.msg)
          }
        })
      } else {
        done()
      }
    },
    statusBtn(id) {
      Dialog.confirm({
        title: '确定通过审核吗',
      }).then(() => {
        Toast.loading({
          mask: true,
          message: '加载中...'
        })
        verifyOrderContinuedApply(
            id,
            1,
        ).then(res => {
          Toast.clear();
          let data = res.data
          if (data.code == 0) {
            this.loadData(true)
            return Toast('审核成功');
          } else {
            Dialog.alert({
              title: '审核失败',
              message: data.msg,
            })
          }
        })
      });
    },

    formatDate(date, format) {
      if (!date) {
        return '';
      }
      if (!format) {
        format = 'YYYY-MM-DD'
      }
      return moment(date).format(format);
    },

    onClerkStatus(item) {
      this.status = item.value
      this.orderStatus.show = false
      this.loadData(true)
    },

    onCherkType(item) {
      this.type = item.value
      this.orderType.show = false
      this.loadData(true)
    },

    loadData(resetFirstPage) {
      // 重置为首页
      if (resetFirstPage) {
        this.pageNo = 1
      }
      // 清空数据
      if (this.pageNo == 1) {
        this.list = [];
      }
      this.loading = true
      continuedApplyList(
          this.status,
          this.keyword,
          this.pageNo,
          this.pageSize
      ).then(res => {
        this.loading = false
        const data = res.data;
        if (data.code == 0) {
          this.list = this.list.concat(data.list)
          if (data.hasNextPage) {
            this.listFinished = false
          } else {
            this.listFinished = true
          }
        } else {
          this.listFinished = true
          Dialog.alert({
            title: '加载失败',
            message: data.msg
          })
        }
        this.pageNo++
      })
    },
    HandleclickImg(photoUrls, index) {
      ImagePreview({
        images: photoUrls,
        startPosition: index,
      });
    }
  },
  updated() {
    // 统一替换标签
    this.$replaceLabel(document.body, this.$store.state.label, true)
  }
}
</script>

<style lang="less" scoped>

.bar {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  height: 40px;
  line-height: 40px;
  padding: 8px 0;
  background: #fff;

  .van-search {
    background: none;
    border-radius: 100px;
    border: 1px solid #999;
    height: 33px;
    width: 130px;
    padding: 0;

    .van-cell {
      padding: 0;
    }

    .van-icon {
      //display: none;
    }
  }
}

.orderlist {

  .list-item {
    padding: 10px 20px;
    color: #000;
    position: relative;

    &:after {
      content: '';
      position: absolute;
      right: 16px;
      left: 16px;
      bottom: 0;
      border-bottom: 1px solid #ebedf0;
      transform: scaleY(.8);
    }

    .dataBox {
      display: flex;

      .wechat {
        margin-right: 30px;
      }
    }

    .tags {
      display: flex;

      .tagsItem {
        margin: 0 6px;
      }
    }

    .status {
      position: absolute;
      top: 20px;
      right: 33px;
    }

    .statusBtn {
      position: absolute;
      top: 45px;
      right: 33px;
      padding: 2px 8px;
      background: #07c160;
      color: #fff;
    }

    .noBtn {
      position: absolute;
      top: 75px;
      right: 33px;
      padding: 2px 8px;
      background: #ee0a24;
      color: #fff;
    }
  }
}
// 申请截图
.img-box {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  .img-style {
    width: 32%;
    padding-top: 32%;
    position: relative;
    margin: 0 0 1.6vw 0;

    img {
      width: 100%;
      height: 100%;
      position: absolute;
      top: 0;
      left: 0;
      display: block;
      object-fit: cover;
      border-radius: 8px;
    }
  }

  .img-no {
    width: 32%;
  }
}


</style>
